:host {
  display: block;
}

cwru-main-nav {
  background: var(--color-lighter-gray);
}
cwru-main-nav cwru-cluster {
  position: relative;
}
cwru-nav-item {
  list-style: none;
}

cwru-main-nav .main-nav cwru-nav-item a {
  display: block;
  padding: var(--s0);
  text-decoration: none;
  outline: 1px solid #fff;
  font-weight: var(--font-weight-bold);
  color: var(--color-cwru-blue) !important;
  font-size: 18px;
  position: relative;
}

cwru-main-nav .main-nav cwru-nav-item a span.arrow {
  height: 67px;
  width: 32px;
  padding-left: 1rem;
  /* display: block;
  position: absolute;
  top: 0;
  right: 0; */
}

cwru-main-nav .main-nav cwru-nav-item a span.arrow::before {
  /* float: right; */
  width: 10px;
  text-align: center;
  display: inline;
  font-size: 18px;
  height: auto;
  content: '';
  font-weight: 400;
  text-shadow: none;
  position: absolute;
  top: 30px;
  right: 17px;
  border: solid var(--color-cwru-blue);
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 4px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  color: #003071;
}

cwru-main-nav .main-nav cwru-nav-item a:hover {
  background: #fff;
  text-decoration: none !important;
}
cwru-main-nav .main-nav cwru-nav-item:hover {
  background: #fff;
}
cwru-main-nav .main-nav cwru-nav-item .active {
  background: var(--color-light-gray);
}

cwru-main-nav cwru-nav-item cwru-sub-nav ul {
  list-style: none;
  padding: 0;
  min-width: 250px;
  position: absolute;
  top: 100%;
  left: 0;
  display: none;
  z-index: 1;
  width: max-content;
  background: var(--color-white);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-clip: padding-box;
}
cwru-main-nav cwru-nav-item .nav-item-div:hover cwru-sub-nav {
  position: absolute;
}
cwru-main-nav .main-nav cwru-nav-item .nav-item-div:hover cwru-sub-nav ul {
  display: block;
}
cwru-main-nav .main-nav cwru-nav-item cwru-sub-nav ul cwru-sub-nav-item li a {
  padding: 13px 21px;
  border-bottom: 2px solid var(--color-lighter-gray);
  font-weight: var(--font-weight-normal);
  font-size: 16px;
}
cwru-main-nav .main-nav cwru-nav-item cwru-sub-nav ul cwru-sub-nav-item li a:hover {
  background: var(--color-off-white);
  color: var(--color-link-blue) !important;
  text-decoration: none !important;
}
